import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTransition } from '../context/TransitionContext';

const LINKS = [
  { label: 'Home',       path: '/' },
  { label: 'Phones',     path: '/phones' },
  { label: 'Wearables',  path: '/wearables' },
  { label: 'Data Deals', path: '/data-deals' },
  { label: 'Fibre',      path: '/fibre' },
  { label: 'Business',   path: '/business' },
];

export default function Navbar() {
  const [open, setOpen]   = useState(false);
  const navigateTo        = usePageTransition();
  const { pathname }      = useLocation();

  const handleNav = (path) => {
    setOpen(false);
    if (path !== pathname) navigateTo(path);
  };

  return (
    <>
      <nav className="top-nav">
        {/* Brand */}
        <button className="top-nav__brand" onClick={() => handleNav('/')}>
          <img src="/Vodacom_Icon.svg" alt="" className="top-nav__logo" aria-hidden="true" />
          <span className="top-nav__brand-name">VODACOM</span>
        </button>

        {/* Desktop links */}
        <ul className="top-nav__links" role="list">
          {LINKS.map(({ label, path }) => (
            <li key={path}>
              <button
                className={`top-nav__link${pathname === path ? ' active' : ''}`}
                onClick={() => handleNav(path)}
              >
                {label}
                <span className="top-nav__link-bar" />
              </button>
            </li>
          ))}
        </ul>

        {/* Mobile hamburger */}
        <button
          className={`top-nav__burger${open ? ' open' : ''}`}
          onClick={() => setOpen(o => !o)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`top-nav__drawer${open ? ' open' : ''}`}
        aria-hidden={!open}
      >
        <div className="top-nav__drawer-inner">
          {LINKS.map(({ label, path }) => (
            <button
              key={path}
              className={`top-nav__drawer-link${pathname === path ? ' active' : ''}`}
              onClick={() => handleNav(path)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Backdrop */}
      {open && (
        <div className="top-nav__backdrop" onClick={() => setOpen(false)} />
      )}
    </>
  );
}
